<!-- FAQ Page-->
<section class="faqPage">
     <div class="cmsHeaderImg"></div>
      <div class="max-800">
            <!-- {{faqList | json}} -->
            <ng-container *ngIf="!!featureTags && !featureTags['sf_faq_content']">
                  <mat-accordion>
                        <ng-container *ngFor="let fq of faqList; let i = index">
                           <mat-expansion-panel hideToggle (afterExpand)="isExpShow(true, i)" (afterCollapse)="isExpShow(false, i)">
                                 <mat-expansion-panel-header>
                                   <mat-panel-title><span class="circleToggle"><mat-icon>{{panelOpenState[i] ? 'remove' : 'add'}}</mat-icon></span>{{fq.title}}</mat-panel-title>
                                 </mat-expansion-panel-header>
                                 <div class="faqContent" [innerHTML]="fq.content"></div>
                             </mat-expansion-panel>
                        </ng-container>
                  </mat-accordion>
            </ng-container>
            <ng-container *ngIf="!!featureTags && featureTags['sf_faq_content']">
                  <mat-accordion *ngIf="faqList && faqList.length > 0">
                        <ng-container *ngFor="let fq of faqList; let i = index">
                           <mat-expansion-panel hideToggle (afterExpand)="isExpShow(true, i)" (afterCollapse)="isExpShow(false, i)">
                                 <mat-expansion-panel-header>
                                   <mat-panel-title><span class="circleToggle"><mat-icon>{{panelOpenState[i] ? 'remove' : 'add'}}</mat-icon></span>{{fq.title}}</mat-panel-title>
                                 </mat-expansion-panel-header>
                                 <div class="faqContent" [innerHTML]="fq.content"></div>
                             </mat-expansion-panel>
                        </ng-container>
                  </mat-accordion>            
            </ng-container>
      </div>
      <section class="btnContent">
            <div class="max-1300 text-center" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                  <img class="imgRes" src="https://hudsonmilk.com/images/3/cms/invoice_logo.jpg" alt="logo">
                  <h3>YOU CAN WHIP OUR CREAM,<br>BUT YOU CAN’T BEAT OUR MILK!</h3>
                  <img src="https://hudsonmilk.com/images/3/cms/hr-line.svg" alt="design">
                  <div class="getSt"><a href="javascript:void(0)" routerLink="/sign-in" class="btnSqRed">GET STARTED</a></div>
              </div>
            <div class="max-1300 text-center" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                <img class="imgRes" src="assets/hudson/files/images/3/content-images/invoice_logo.jpg" alt="logo">
                <h3>YOU CAN WHIP OUR CREAM,<br>BUT YOU CAN’T BEAT OUR MILK!</h3>
                <img src="/assets/hudson/files/images/3/content-images/hr-line.svg" alt="design">
                <div class="getSt"><a href="javascript:void(0)" routerLink="/sign-in" class="btnSqRed">GET STARTED</a></div>
            </div>
      </section>
</section>
